export const genericCustomFieldsMock: any[] = [
  {
    name: 'strText R',
    type: 'str',
    label: 'Text R',
    value: 'Mon Text',
    dropDownValues: []
  },
  {
    name: 'strText',
    type: 'str',
    label: 'Text',
    value: '',
    dropDownValues: []
  },
  {
    name: 'dateDate R',
    type: 'date',
    label: 'Date R',
    value: '2022-08-11',
    dropDownValues: []
  },
  {
    name: 'dateDate',
    type: 'date',
    label: 'Date',
    value: '2022-08-25',
    dropDownValues: []
  }
];
